import { render } from "./ProductCardSolarWithPanelCount.vue?vue&type=template&id=2c827860&scoped=true"
import script from "./ProductCardSolarWithPanelCount.vue?vue&type=script&lang=js"
export * from "./ProductCardSolarWithPanelCount.vue?vue&type=script&lang=js"

import "./ProductCardSolarWithPanelCount.vue?vue&type=style&index=0&id=2c827860&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c827860"]])

export default __exports__